import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import CoursesSubthemeItem from "../../items/courses/CoursesSubthemeItem";

export default function CoursesSubthemesList({subthemes, selectSubtheme, selectedSubtheme}) {
    // Used in GradeMobileContent and LevelDesktopContent to
    // display list of flash levels to pick

    // BUILD
    if (isArrayNullUndefinedOrEmpty(subthemes))
        return null
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-2/5 grow flex flex-col items-start justify-start border-r-1 border-backgroundLight5 pb-[10px]"}>
            {subthemes?.map((subtheme, index) => (
                <CoursesSubthemeItem key={index}
                                     index={index}
                                     total={subthemes.length}
                                     subtheme={subtheme}
                                     selectSubtheme={selectSubtheme}
                                     selectedSubtheme={selectedSubtheme} />
            ))}
        </div>
    );
}